import { baseUrl } from '@/config/constants';

export const tourAPI = Object.freeze({
  addNew: async (categoryId: number, tourId?: number) => {
    const body: Record<string, string | number> = { categoryId };
    if (tourId) body.tourId = tourId;

    const url = new URL(`${baseUrl}/tour/category`);
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) throw new Error(`Erro: ${res.status}`);
    const data = await res.json();
    return data;
  },
});
